<template>
	<v-app-bar
			app
			color="blue darken-4"
			dark>
		<v-app-bar-nav-icon 
			v-if="Auth.isLoggedIn()"
			@click.stop="$emit('toggle-drawer')" />
		<v-toolbar-title class="d-md-none">Online Enrollment</v-toolbar-title>
		<v-toolbar-title class="d-none d-md-flex">KorPhil Davao Online Enrollment</v-toolbar-title>

		<v-spacer></v-spacer>
		

		<!-- <v-tooltip bottom>  
			<template v-slot:activator="{ on }">
				<v-btn v-on="on"
					icon @click="$router.push({ name: 'search'})">
					<v-icon dark>mdi-magnify</v-icon>
				</v-btn>
			</template>
			<span>Search</span>
		</v-tooltip> -->


		<!-- <v-btn color="white" text
			@click="$router.push({ name: 'login' })"
			v-if="!Auth.isLoggedIn()">
				Login
		</v-btn> -->


		<!-- FOR BAR -->
		<router-link class="d-none d-md-flex"
			v-for="(link, key) in links" v-bind:key="key"
			:to="link.to"
			tag="v-btn">
			<v-btn color="white" text
				v-show="link.inBar">
				{{ link.label }}	
			</v-btn>
		</router-link>

		<!-- <v-btn color="white" text
			@click="Auth.logout()"
			v-if="Auth.isLoggedIn()">
				Logout
		</v-btn> -->


		<v-menu
			left
			bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					v-bind="attrs"
					v-on="on">
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>

			<v-list>
				<!-- FOR MENU -->
				<router-link class="d-none d-md-flex"
					v-for="(link, key) in links" v-bind:key="key"
					:to="link.to" tag="v-btn">
					<v-list-item @click="() => {}"
						v-show="link.inMenu">
						{{ link.label }}
					</v-list-item>
				</router-link>

				<router-link class="d-flex d-md-none"
					v-for="(link, key) in links" v-bind:key="key"
					:to="link.to" tag="v-btn">
					<v-list-item @click="() => {}">
						{{ link.label }}
					</v-list-item>
				</router-link>
			</v-list>
		</v-menu>

	
	</v-app-bar>
</template>

<script>
import Auth from '../../services/auth'

export default {
		name: 'AppBar',
		props: ['drawer'],
		data() {
			return {
				Auth,
				links: [
					{ to: { name: 'home' }, label: 'Home', inBar: true, inMenu: false },
					{ to: { name: 'register' }, label: 'Enroll', inBar: true, inMenu: false },
					// { to: { name: 'announcements' }, label: 'Announcements', inBar: true, inMenu: false },
					{ to: { name: 'bsrs' }, label: 'BSRS', inBar: true, inMenu: false },
					{ to: { name: 'requirements' }, label: 'Requirements', inBar: true, inMenu: false },
					{ to: { name: 'scholarships' }, label: 'Scholarships', inBar: false, inMenu: true },
					{ to: { name: 'healthProtocol' }, label: 'Health Protocol', inBar: false, inMenu: true },
				]
			}
		},
		methods: {
		}
}
</script>